import { loginActions } from "../../constants/loginActionTypes";

const INITIAL_STATE = {
  resource_permissions: ["list"],
  logoutData: {},
  loginDetails: "",
  loginDetailsError: "",
  invalidTenantUrl: "",
  onboardingFalseData: "",
  onboardingFalseError: "",
  authTokenSuccess: "",
  authTokenError: "",
  logoutFailData: "",
  localUserTokenData: "",
  localUserLoginError: "",
  localUserSignupSuccess: "",
  localUserForgotPasswordSuccess: "",
  localUserForgotPasswordError: "",
  localUserResetPasswordSuccess: "",
  localUserResetPasswordError: "",
  localUserSignupError: "",
  idpAuthToken: {},
  verifiedLocalUser: {},
  inValidLocalUser: {},
  verifiedWorkSpaceLocalUser: {},
  invalidWorkSpaceLocalUser: {},
  workspaceLoginSuccess: {},
  workspaceLoginError: {},
};

const userAuthentication = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case loginActions.apiActionSet:
      return {
        ...state,
        resource_permissions: action?.payload,
      };
    case loginActions.LOGOUT_USER_SUCCESS:
      return {
        ...state,
        logoutData: action?.payload,
      };
    case loginActions.LOGOUT_USER_FAILED:
      return {
        ...state,
        logoutFailData: action.payload,
      };
    case loginActions.GET_LOGIN_DETAILS_SUCCESS: {
      return {
        ...state,
        loginDetails: action?.payload,
      };
    }
    case loginActions.SET_LOGIN_DETAILS_ERROR: {
      return {
        ...state,
        loginDetailsError: action?.payload,
      };
    }
    case loginActions.LOGIN_ACTION_SUCCESS: {
      return {
        ...state,
        onboardingFalseData: action?.payload,
      };
    }
    case loginActions.LOGIN_ACTION_FAIL: {
      return {
        ...state,
        onboardingFalseError: action?.payload,
      };
    }
    case loginActions.GET_AUTH_TOKEN_SUCCESS: {
      return {
        ...state,
        authTokenSuccess: action?.payload,
      };
    }
    case loginActions.GET_AUTH_TOKEN_FAIL: {
      return {
        ...state,
        authTokenError: action?.payload,
      };
    }
    case loginActions.SET_INVALID_TENANT_URL: {
      return {
        ...state,
        invalidTenantUrl: action?.payload,
      };
    }
    case loginActions.SET_LOCAL_USER_TOKEN: {
      return {
        ...state,
        localUserTokenData: action?.payload,
      };
    }
    case loginActions.SET_LOCAL_USER_SIGNUP_SUCCESS: {
      return {
        ...state,
        localUserSignupSuccess: action?.payload,
      };
    }
    case loginActions.SET_LOCAL_USER_FORGOT_PASSWORD_SUCCESS: {
      return {
        ...state,
        localUserForgotPasswordSuccess: action?.payload,
      };
    }
    case loginActions.SET_LOCAL_USER_RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        localUserResetPasswordSuccess: action?.payload,
      };
    }
    case loginActions.SET_LOCAL_USER_FORGOT_PASSWORD_ERROR: {
      return {
        ...state,
        localUserForgotPasswordError: action?.payload,
      };
    }
    case loginActions.SET_LOCAL_USER_RESET_PASSWORD_ERROR: {
      return {
        ...state,
        localUserResetPasswordError: action?.payload,
      };
    }
    case loginActions.SET_LOCAL_USER_SIGNUP_ERROR: {
      return {
        ...state,
        localUserSignupError: action?.payload,
      };
    }
    case loginActions.SET_LOCAL_USER_LOGIN_ERROR: {
      return {
        ...state,
        localUserLoginError: action?.payload,
      };
    }
    case loginActions.SET_IDP_TOKEN: {
      let obj = {
        data: { ...action?.payload?.data },
        status: action?.payload?.status,
      };
      return {
        ...state,
        idpAuthToken: Object.assign({}, obj),
      };
    }
    case loginActions.VERIFIED_LOCAL_USER: {
      return {
        ...state,
        verifiedLocalUser: action?.payload,
      };
    }
    case loginActions.INVALID_LOCAL_USER: {
      return {
        ...state,
        inValidLocalUser: action?.payload,
      };
    }
    case loginActions.VERIFIED_WORKSPACE_LOCAL_USER: {
      return {
        ...state,
        verifiedWorkSpaceLocalUser: action?.payload,
      };
    }
    case loginActions.INVALID_WORKSPACE_LOCAL_USER: {
      return {
        ...state,
        invalidWorkSpaceLocalUser: action?.payload,
      };
    }
    case loginActions.WORKSPACE_LOCAL_USER_LOGIN_SUCCESS: {
      return {
        ...state,
        verifiedWorkSpaceLocalUser: {},
        workspaceLoginSuccess: action?.payload,
      };
    }
    case loginActions.WORKSPACE_LOCAL_USER_LOGIN_ERROR: {
      return {
        ...state,
        workspaceLoginError: action?.payload,
      };
    }
    default:
      return state;
  }
};

export default userAuthentication;
